import { LocaleService } from '../services/locale.service';
import { UnitSystem, UnitConversionValueWithUnitOnly } from '../types/unit-system';

export abstract class UnitConversionBasePipe {
  constructor(protected readonly _localeService: LocaleService) {}

  protected convertAndFormat(
    value: UnitConversionValueWithUnitOnly,
    precision: number,
    includeUnit: boolean,
    sourceUnit: UnitSystem,
    convertFn: (value: number, from: UnitSystem, to: UnitSystem) => number,
    getUnitSymbol: (system: UnitSystem) => string,
    unitSeparator: string = ' '
  ): string {
    if (value == null) return '';
    const unitConfig = this._localeService.getUnitConfig();
    if (value === 'unit-only') return getUnitSymbol(unitConfig.system);

    const convertedValue = convertFn(value, sourceUnit, unitConfig.system);
    const formattedValue = this._localeService.formatNumber(convertedValue, precision, precision);
    const unit = getUnitSymbol(unitConfig.system);
    return includeUnit ? `${formattedValue}${unitSeparator}${unit}` : formattedValue;
  }
}

